import { apiRequest } from './api';

export interface TarefaExecucao {
  id: number;
  tarefa_id: number;
  data_execucao: string;
  mes_referencia: string;
  usuario_id_executou?: number;
  nome_executou?: string;
  observacoes?: string;
  createdAt?: string;
  updatedAt?: string;
  executor?: {
    id: number;
    nome: string;
  };
}

export interface Tarefa {
  id: number;
  titulo: string;
  descricao?: string;
  observacoes?: string;
  tipo_agendamento: 'data' | 'recorrente';
  data_agendada?: string;
  dia_recorrente?: number;
  status: 'pendente' | 'executada';
  criado_por: number;
  setor?: string;
  hora_tarefa?: string;
  createdAt?: string;
  updatedAt?: string;
  execucoes?: TarefaExecucao[];
  criador?: {
    id: number;
    nome: string;
  };
  executor?: {
    id: number;
    nome: string;
  };
}

export const tarefaService = {
  getTarefas: async () => {
    return await apiRequest.get('/tarefas');
  },
  
  getTarefaById: async (id: number) => {
    return await apiRequest.get(`/tarefas/${id}`);
  },

  getDashboardStats: async () => {
    return await apiRequest.get('/tarefas/dashboard');
  },

  createTarefa: async (data: Partial<Tarefa>) => {
    return await apiRequest.post('/tarefas', data);
  },

  updateTarefa: async (id: number, data: Partial<Tarefa>) => {
    return await apiRequest.put(`/tarefas/${id}`, data);
  },

  deleteTarefa: async (id: number) => {
    return await apiRequest.delete(`/tarefas/${id}`);
  },

  marcarExecutada: async (id: number, data: { observacoes?: string; data_execucao: string; usuario_id_executou?: number | null; nome_executou?: string | null; mes_referencia?: string }) => {
    return await apiRequest.post(`/tarefas/${id}/executar`, data);
  }
};
